import LogoAnzSrc from '../anz/assets/Logo.svg'

const useLogoProps = () => {
  return {
    src: LogoAnzSrc,
  }
}

export default useLogoProps
